import { getInstance } from './tools';

export function getMenu() {
    return getInstance().get('/categories');
}
